import { render, staticRenderFns } from "./ModuleDeleted.vue?vue&type=template&id=1c4ed8f6"
import script from "./ModuleDeleted.vue?vue&type=script&lang=js"
export * from "./ModuleDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports